import { Highlight } from "client/Components";
import { useMemo } from "react";
import { groupBy } from "client_legacy/ndaw/arrayHelpers";
import { HighlightItem } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { ensureNotNil } from "client/Misc/utils";

export function useHighlights(
	hitHighlights: readonly HighlightItem[]
): Map<string, Highlight>
{
	return useMemo(
		(): Map<string, Highlight> => {

			const result = new Map<string, Highlight>();

			const highlightsByField: Partial<Record<string, HighlightItem[]>> = groupBy(hitHighlights, x => x.highlightedField);

			for (const [field, highlights] of Object.entries(highlightsByField)) {
				const {
					startPosition,
					fragmentLength
				} = ensureNotNil(highlights)[0];

				result.set(
					field,
					[startPosition, fragmentLength]
				);
			}

			return result;
		},
		[hitHighlights]
	);
}